import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { setupAdminI18n, i18n } from "./i18n/index.js";
import App from "./App.js";
import "./globals.css";

// Initialize i18n BEFORE React mount — detector reads localStorage (i18nextLng)
// so the restored language is applied synchronously (no flash), mirroring the
// desktop renderer's setup-before-mount pattern.
setupAdminI18n();

const root = document.getElementById("root");
if (!root) {
  throw new Error("[admin-portal-web] #root missing in index.html");
}

createRoot(root).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);
